import React from "react";

import CardsOptions from "./CardsOptions";
import CardOptions from "./CardOptions";
import LinkSidebarTransition from "@Shared/Components/LinkSidebar";
import BackgroundPopup from "@Shared/Components/Background/BackgroundPopup";
import IconsSidebar from "@Shared/Components/IconsSidebar";
import { CARDS_PROP } from "./defaults";
import { useCardsStore } from "../../../../../../stores/use-cards-store";

const CardsSettings = () => {
  const { data, card, action, setAction, updateCardData } = useCardsStore(
    (state) => ({
      data: state.data,
      card: state.card,
      action: state.action,
      setAction: state.setAction,
      updateCardData: state.updateCardData,
    })
  );

  const selectedCard = data.reduce(
    (acc, { card }) => (card.id === action?.card?.card?.id ? card : acc),
    {}
  );

  const CardsSettingsComponent = card ? CardOptions : CardsOptions;
  const isEmoji = action && typeof action.card.card.icon === "object";

  const updateIcon = (value) => {
    updateCardData({
      id: selectedCard.id,
      key: CARDS_PROP.ICON,
      value,
    });
    setAction(undefined);
  };

  return (
    <>
      {action && action.drawer === "link" && (
        <LinkSidebarTransition
          isOpen={action.drawer === "link"}
          setIsOpen={() => setAction(undefined)}
          value={selectedCard.link}
          onChange={(value) => {
            updateCardData({
              id: selectedCard.id,
              key: CARDS_PROP.LINK,
              value,
            });
            setAction(undefined);
          }}
        />
      )}

      {action && action.drawer === "icon" && (
        <IconsSidebar
          isOpen={action.drawer === "icon"}
          setIsOpen={() => setAction(undefined)}
          containerStyles={{ top: "75px" }}
          onEmojiChange={updateIcon}
          onIconChange={updateIcon}
          onAppChange={updateIcon}
          selectedIcon={isEmoji ? selectedCard.icon?.value : selectedCard?.icon}
          tabs={["Icons", "Emojis", "Logos"]}
          activeTab={isEmoji ? "Emojis" : "Icons"}
        />
      )}

      {action && action.drawer === "image" && (
        <BackgroundPopup
          dialogPositionCss={{
            top: "75px",
            bottom: 0,
          }}
          isOpen={action.drawer === "image"}
          image={selectedCard.image || {}}
          resetOnDifferentImages={true}
          overlay={{}}
          position="absolute"
          onClose={() => setAction(undefined)}
          unsplash={{}}
          setImage={(value) => {
            updateCardData({
              id: selectedCard.id,
              key: CARDS_PROP.IMAGE,
              value,
            });

            if (value.source !== "link") {
              setAction(undefined);
            }
          }}
          linkToDocs="https://caelor.atlassian.net/wiki/spaces/MAC/pages/611614721"
        />
      )}

      {!action && <CardsSettingsComponent />}
    </>
  );
};

export default CardsSettings;
